let clientLineId = 0;

export function createBlankLine() {
  clientLineId += 1;
  return {
    CLIENTID: `quote-line-${clientLineId}`,
    SORTORDER: 0,
    LINETYPE: 'part',
    PRODUCTID: null,
    DESCRIPTION: '',
    QTY: '',
    UNIT: 'EA',
    UNITPRICE: '',
    DISCOUNTPCT: 0,
    PRICELISTID: null,
  };
}

export function isLineStarted(line = {}) {
  return !!(
    line.PRODUCTID ||
    String(line.DESCRIPTION || '').trim() ||
    Number(line.QTY || 0) ||
    Number(line.UNITPRICE || 0) ||
    Number(line.DISCOUNTPCT || 0) ||
    line.LINETYPE === 'nonstock' ||
    line.LINETYPE === 'comment'
  );
}

export function ensureTrailingBlankLine(lines) {
  if (!Array.isArray(lines)) return;

  for (let i = lines.length - 2; i >= 0; i -= 1) {
    if (!isLineStarted(lines[i])) {
      // Prefer dropping a following blank over this empty row so clearing the
      // search input keeps the same DOM node (and focus) as the trailing blank.
      if (!isLineStarted(lines[i + 1])) {
        lines.splice(i + 1, 1);
      } else {
        lines.splice(i, 1);
      }
    }
  }

  if (!lines.length || isLineStarted(lines[lines.length - 1])) {
    lines.push(createBlankLine());
  }
}

function productForItem(item, quoteProducts = []) {
  if (!item?.PRODUCTID) return null;
  return quoteProducts.find((p) => p.PRODUCTID?.toUpperCase() === item.PRODUCTID?.toUpperCase()) || null;
}

function partNumberForItem(item, quoteProducts = []) {
  const product = productForItem(item, quoteProducts);
  if (product?.PARTNUM) return String(product.PARTNUM).trim();

  const description = String(item.DESCRIPTION || '').trim();
  if (!description) return '';
  const dashIndex = description.indexOf(' - ');
  return dashIndex >= 0 ? description.slice(0, dashIndex).trim() : description;
}

export function buildLineItemsClipboardText(items = [], quoteProducts = []) {
  const values = [];

  for (const item of items) {
    if (item.LINETYPE === 'comment' || item.LINETYPE === 'nonstock') continue;
    if (!isLineStarted(item)) continue;

    const partNumber = partNumberForItem(item, quoteProducts);
    if (!partNumber) continue;

    values.push(partNumber, String(item.QTY ?? ''), String(item.UNIT || 'EA').toUpperCase());
  }

  return values.join('|');
}

export function normalizeLineItemsForSave(lines = []) {
  return lines
    .filter(isLineStarted)
    .map((line, index) => {
      const lineType = line.LINETYPE || 'part';

      if (lineType === 'comment') {
        return {
          ITEMID: line.ITEMID || undefined,
          PRODUCTID: null,
          SORTORDER: index,
          LINETYPE: 'comment',
          DESCRIPTION: String(line.DESCRIPTION || '').trim() || null,
          QTY: 0,
          UNIT: 'EA',
          UNITPRICE: 0,
          DISCOUNTPCT: 0,
          PRICELISTID: null,
        };
      }

      return {
        ITEMID: line.ITEMID || undefined,
        PRODUCTID: lineType === 'part' ? line.PRODUCTID || null : null,
        SORTORDER: index,
        LINETYPE: lineType,
        DESCRIPTION: String(line.DESCRIPTION || '').trim() || null,
        QTY: line.QTY === '' || line.QTY === null || line.QTY === undefined ? 0 : Number(line.QTY),
        UNIT: line.UNIT || 'EA',
        UNITPRICE: line.UNITPRICE === '' || line.UNITPRICE === null || line.UNITPRICE === undefined ? 0 : Number(line.UNITPRICE),
        DISCOUNTPCT: line.DISCOUNTPCT === '' || line.DISCOUNTPCT === null || line.DISCOUNTPCT === undefined ? 0 : Number(line.DISCOUNTPCT),
        PRICELISTID: line.PRICELISTID || null,
      };
    });
}
